import { useEffect } from "react";

const BLOCKED_KEYS = new Set(["s", "c", "u"]);

export default function ContentGuard() {
  useEffect(() => {
    const onContext = (e) => e.preventDefault();
    const onKey = (e) => {
      const k = e.key?.toLowerCase();
      const isField = ["INPUT", "TEXTAREA"].includes(e.target?.tagName);
      if ((e.ctrlKey || e.metaKey) && BLOCKED_KEYS.has(k) && !(isField && k === "c")) e.preventDefault();
    };
    const onDrag = (e) => { if (e.target?.tagName === "IMG") e.preventDefault(); };
    document.addEventListener("contextmenu", onContext);
    document.addEventListener("keydown", onKey);
    document.addEventListener("dragstart", onDrag);
    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("dragstart", onDrag);
    };
  }, []);
  return null;
}
